import Usuario from "model/administracao/cadastro/Usuario";
import Documento from "./Documento";
import DocumentoVersaoLocal from "./DocumentoVersaoLocal";
import { BaseModel } from "model/BaseModel";
import Arquivo from "model/arquivo/Arquivo";
import DocumentoVersaoConfirmacaoLeitura from "./DocumentoVersaoConfirmacaoLeitura";
import { Nullable } from "primereact/ts-helpers";

export default class DocumentoVersao implements BaseModel {
    id: number;
    codigo: string | null = "";
    sequencial: number;
    validade: Date | null;
    prazo: Date | null;
    status: string;
    vigente: boolean;
    temAprovacao: boolean;
    documento: Documento | null;
    usuarioResponsavel: Usuario | null;
    usuarioCriacao: Usuario | null;
    usuarioRevisao: Usuario | null;
    usuarioAprovacao: Usuario | null;
    prazoRevisao: Date | null;
    prazoAprovacao: Date | null;
    observacaoParaRevisao: string | null;
    observacaoRevisao: string;
    observacaoAprovacao: string;
    motivoReprovacao: string;
    prazoConfirmacaoLeitura: Date | null;
    diasConfirmacaoLeitura: number | null;
    dataPublicacao: Date | null;
    linkDocs: string | null;
    idDocs: string | null;
    arquivo: Arquivo | null;
    locais: DocumentoVersaoLocal[];
    confirmacaoLeitura: DocumentoVersaoConfirmacaoLeitura[];
    constructor(
        id: number = 0,
        sequencial: number = 0,
        validade: Date | null = null,
        prazo: Date | null = null,
        status: string = "EM_ELABORACAO",
        vigente: boolean = false,
        temAprovacao: boolean = false,
        documento: Documento | null = null,
        usuarioResponsavel: Usuario | null = null,
        usuarioCriacao: Usuario | null = null,
        usuarioRevisao: Usuario | null = null,
        usuarioAprovacao: Usuario | null = null,
        prazoRevisao: Date | null = null,
        prazoAprovacao: Date | null = null,
        observacaoParaRevisao: string | null = null,
        observacaoRevisao: string = "",
        observacaoAprovacao: string = "",
        motivoReprovacao: string = "",
        prazoConfirmacaoLeitura: Date | null = null,
        diasConfirmacaoLeitura: number | null = null,
        dataPublicacao: Date | null = null,
        linkDocs: string | null = null,
        idDocs: string | null = null,
        arquivo: Arquivo | null = null,
        locais: DocumentoVersaoLocal[] = [],
        confirmacaoLeitura: DocumentoVersaoConfirmacaoLeitura[] = []
    ) {
        this.id = id;
        this.sequencial = sequencial;
        this.validade = validade;
        this.prazo = prazo;
        this.status = status;
        this.vigente = vigente;
        this.temAprovacao = temAprovacao;
        this.documento = documento;
        this.usuarioResponsavel = usuarioResponsavel;
        this.usuarioCriacao = usuarioCriacao;
        this.usuarioRevisao = usuarioRevisao;
        this.usuarioAprovacao = usuarioAprovacao;
        this.prazoRevisao = prazoRevisao;
        this.prazoAprovacao = prazoAprovacao;
        this.observacaoParaRevisao = observacaoParaRevisao;
        this.observacaoRevisao = observacaoRevisao;
        this.observacaoAprovacao = observacaoAprovacao;
        this.motivoReprovacao = motivoReprovacao;
        this.prazoConfirmacaoLeitura = prazoConfirmacaoLeitura;
        this.diasConfirmacaoLeitura = diasConfirmacaoLeitura;
        this.dataPublicacao = dataPublicacao;
        this.linkDocs = linkDocs;
        this.idDocs = idDocs;
        this.arquivo = arquivo;
        this.locais = locais;
        this.confirmacaoLeitura = confirmacaoLeitura;
    }
}